import { httpClient } from './httpClient';

export interface PresignAudioRequest {
  contentPlanId: string;
  postId?: string;
  contentType?: string;
  durationMs?: number;
}

export interface PresignAudioResponse {
  uploadUrl: string;
  key: string;
  fileUrl: string;
}

export async function presignPostChatAudio(request: PresignAudioRequest): Promise<PresignAudioResponse> {
  const res = await httpClient.post('/media/presign-audio', {
    contentPlanId: request.contentPlanId,
    postId: request.postId,
    contentType: request.contentType,
    durationMs: request.durationMs
  });

  return {
    uploadUrl: res.uploadUrl ?? res.UploadUrl,
    key: res.key ?? res.Key,
    fileUrl: res.fileUrl ?? res.FileUrl
  };
}

export interface PresignImagesRequest {
  contentPlanId: string;
  postId?: string;
  contentTypes: string[];
}

export interface PresignImageResponseItem {
  uploadUrl: string;
  key: string;
  fileUrl: string;
}

export interface PresignImagesResponse {
  images: PresignImageResponseItem[];
}

export async function presignPostChatImages(request: PresignImagesRequest): Promise<PresignImagesResponse> {
  const res = await httpClient.post('/media/presign-images', {
    contentPlanId: request.contentPlanId,
    postId: request.postId,
    count: request.contentTypes.length,
    contentTypes: request.contentTypes
  });

  // Backend returns { items: [...] } / { Items: [...] }, keep backward compatibility with { images: [...] } too.
  const imagesRaw = res?.items ?? res?.Items ?? res?.images ?? res?.Images ?? [];
  const images: PresignImageResponseItem[] = (Array.isArray(imagesRaw) ? imagesRaw : []).map((x: any) => ({
    uploadUrl: x.uploadUrl ?? x.UploadUrl,
    key: x.key ?? x.Key,
    fileUrl: x.fileUrl ?? x.FileUrl
  }));

  return { images };
}

export async function uploadBlobToPresignedPut(
  uploadUrl: string,
  blob: Blob,
  contentType: string,
  timeoutMs = 45000
): Promise<void> {
  if (!uploadUrl) {
    throw new Error('S3 upload failed: missing uploadUrl');
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const resp = await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType
      },
      body: blob,
      signal: controller.signal
    });

    if (!resp.ok) {
      let details = '';
      try {
        details = await resp.text();
      } catch {
        // ignore (CORS can block reading body)
      }
      throw new Error(`S3 upload failed: HTTP ${resp.status}${details ? ` - ${details}` : ''}`);
    }
  } finally {
    clearTimeout(timeout);
  }
}


